import React from 'react';

import AbstractComponent from "components/Abstract";
import MenuPopup from "components/MenuPopup";
import MenuItemsComponent from "components/MenuItems";
import DropDown from "components/DropDown";
import ConfirmDialog from 'components/ConfirmDialog';

import { ReactComponent as MenuIcon } from 'icons/hamburger.svg';
import { ReactComponent as ExitIcon } from 'icons/exit.svg';
import ItemPerson from './ItemPerson';

export default class Page extends AbstractComponent {
    constructor(props) {
        super(props);

        const urlProps = this._helper.getUrlOptions();
        const clinicId = urlProps.domainId ? parseInt(urlProps.domainId, 10) : (this._helper.storage("lastClinicId") || null);
        const profile = this._helper.storage("employee") || {};

        this.state = {
            menuOpened: false,
            cabinets: [],
            clinics: [],
            insurance: [],
            doctors: [],
            reasons: [],
            recommendationTypes: [],
            anketaQuestions: [],
            anketaAnswers: [],
            clinicId,
            profile,
            urlProps
        };

        this.useTooltip = true;

        const page = window.location.pathname.replace("/", "");
        this.setPageTitle(this.tr("menu", page));
    }

    get rightPopupsMap() {
        return {};
    }

    get dialogsMap() {
        return {};
    }

    componentDidMount() {
        super.componentDidMount();

        window.notifyPopup = this.notifyPopup;

        this.startup = true;

        const tm = setTimeout(() => {
            clearTimeout(tm);
            this.getMainData();
        }, 10);
    }

    componentDidLoad() {

    }

    componentWillUnmount() {
        this._helper.disconnect(this.menuCloseCnt);
    }

    setPageTitle(name) {
        const { title } = this._config;

        document.title = title + (name ? ` - ${name}` : "");
    }

    checkVersion() {
        const { version } = globalThis.packageInfo;
        const localVersion = this._helper.storage("version");
        if (localVersion !== version) {
            this._helper.storage("version", version);
            this._helper.storage("cacheData", "");
            this._helper.storage("cacheDates", "");
            localStorage.removeItem('cacheData');
            localStorage.removeItem('cacheDates');
            return this._helper.showNotifyPopup({
                type: "success",
                label: `${this.tr("main.version")} ${version}`,
                text: this.tr("main.versionUpdated")
            });
        }
    }

    async getMainData() {
        this.checkVersion();

        this._helper.showLoading();

        const clinicsResp = await this._request.clinics.getAll();
        const clinics = (clinicsResp?.data || []).filter(it => (it.id !== 1586 && it.id !== 1602));

        const insuranceResp = await this._request.insurance.getAll();
        const insurance = (insuranceResp?.data || []);

        const citiesResp = await this._request.cities.getAll();
        const cities = citiesResp?.data || [];

        const doctorsResp = await this._request.doctors.getAll();
        const doctors = doctorsResp?.data || [];

        const employeesResp = await this._request.employees.getAll();
        const employees = employeesResp?.data || [];

        const cabinetsResp = await this._request.cabinets.getAll();
        const cabinets = cabinetsResp?.data || [];

        const reasonsResp = await this._request.reasons.getAll();
        const reasons = reasonsResp?.data || [];

        const recsResp = await this._request.recommendationTypes.getAll();
        const recommendationTypes = recsResp?.data || [];

        const anketaAnswersResp = await this._request.anketaAnswers.getAll();
        const anketaAnswers = anketaAnswersResp?.data || [];

        const anketaQuestionsResp = await this._request.anketaQuestions.getAll();
        const anketaQuestions = anketaQuestionsResp?.data || [];

        /*if (clinics?.length > 0 && clinics[2])
            clinics[2].offsetTimeZoneInt = -5;*/

        let clinicId = this.state.clinicId || (clinics.length > 0 ? clinics[0]?.id : null);

        this.setState({
            clinics,
            insurance,
            doctors,
            employees,
            cabinets,
            reasons,
            recommendationTypes,
            anketaAnswers,
            anketaQuestions,
            clinicId,
            cities
        }, () => {
            this.setDateTz();
            this.componentDidLoad();
        });

        this._helper.hideLoading();

    }

    setDateTz() {
        const offsetTimeZoneInt = this._helper.getCurrClinic()?.offsetTimeZoneInt || 0;
        this._helper.date.tz = parseInt(offsetTimeZoneInt) || 0;
    }

    toggleMenu() {
        const menuOpened = !this.state.menuOpened;

        this._helper.disconnect(this.menuCloseCnt);

        if (menuOpened) {
            const tm = setTimeout(() => {
                clearTimeout(tm);
                this.menuCloseCnt = this._helper.on(window, "click", () => {
                    this._helper.disconnect(this.menuCloseCnt);
                    this.toggleMenu();
                });
            }, 50);
        }

        this.setState({ menuOpened });
    }

    openRightPopup(key) {
        const popup = this[`${key}Popup`];

        if (popup?.show) {
            const args = Array.from(arguments);
            args.shift();

            popup.show.apply(popup, args);
        }
        else
            console.warn("Error openRightPopup", key);
    }

    openDialog(key) {
        const dialog = this[`${key}Dialog`];
        if (dialog?.show) {
            const args = Array.from(arguments);
            args.shift();

            dialog.show.apply(dialog, args);
        }
        else
            console.warn("Error openDialog", key);
    }

    getDoctorById(id) {
        const doctor = this.state.doctors.find(it => it.id === id);
        return doctor?.domainId ? doctor : {};
    }

    getEmployeById(id) {
        const employe = this.state.employees.find(it => it.id === id);
        return employe ? employe : {};
    }

    getKnowAboutTitleById(id) {
        const item = this.state.recommendationTypes.find(it => it.id === id);
        return item?.title ? this._helper.string.capitalize(item?.title) : this.tr("main.notIndicated");
    }

    _onClinicChanged(clinicId) {
        this._helper.storage("lastClinicId", clinicId);

        this.state.clinicId = clinicId;

        this.setDateTz();

        this.onClinicChanged(clinicId);
    }

    onClinicChanged(clinicId) {

    }

    showError(text, label) {
        this._helper.showNotifyPopup({
            type: "error",
            label: this.tr(label || "server.error"),
            text: this.tr(text),
        });
    }

    renderMenu() {
        return (
            <MenuPopup
                opened={this.state.menuOpened}
                toggleMenu={this.toggleMenu.bind(this)}
            />
        );
    }

    insertClinicsSelector() {
        return (<DropDown
            placeHolder={"login.clinic"}
            value={this.state.clinicId}
            items={this.state.clinics}
            onChange={this._onClinicChanged.bind(this)}
        />);
    }

    insertSmallMenu() {
        const { pagesShort } = this._config;
        const currentUrl = window.location.href;

        return (<>
            <MenuItemsComponent
                className="smallMenu flex"
                menuItems={pagesShort}
                showLabel={false}
                value={this.currPage()}
            />
            {currentUrl.includes("/client#") && this.insertTree("1", "300px")}
            {/*this.insertTree("-1", "120px")*/}
            {/*this.insertTree("-1", "70px")*/}
            {/*this.insertTree("-1", "70px")*/}
            {/*this.insertTree("-1", "70px")*/}
        </>

        );
    }

    renderHeader() {
        return (
            <div className="header flex between centerV">
                <div className="left flex centerV">
                    <MenuIcon width="24px" className="hand" onClick={this.toggleMenu.bind(this)} />
                    {this.insertLogo()}
                    {this.insertClinicsSelector()}
                    {this.insertSmallMenu()}

                </div>
                <div className="right flex centerV">
                    <ItemPerson info={this.state.profile} type={"default"} />
                    <ExitIcon className="hand" width="14px" height="16px" data-tooltip="main.exit" onClick={this._helper.logout.bind(this)} />
                </div>
            </div>
        );
    }

    renderPage() {
        return <></>;
    }

    render() {
        globalThis.appPageView = this;
        const dialogsMap = this.dialogsMap;
        dialogsMap["confirmAbstract"] = ConfirmDialog;

        return (
            <>
                <div className="view flex1 flex col minW0">
                    {this.renderHeader()}
                    <div className={`container ${this.currPage()}Page flex1 flex minH0 hidden`}>
                        {!!this.startup && this.renderPage()}
                    </div>
                    {this.renderMenu()}
                </div>
                {Object.keys(this.rightPopupsMap).map(key => {
                    const PopupComponent = this.rightPopupsMap[key];

                    return (
                        <PopupComponent
                            key={key}
                            ref={el => this[`${key}Popup`] = el}
                            getDoctorById={this.getDoctorById.bind(this)}
                        />
                    );
                })}
                {Object.keys(dialogsMap).map(key => {
                    const DialogComponent = dialogsMap[key];

                    return <DialogComponent key={key} ref={el => this[`${key}Dialog`] = el} />;
                })}
            </>
        );
    }
}
